import { useMutation } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

import { broadcastPropsUpdated } from '../../../../components/preview-messages';

import { multipartFormDataConfig } from '../../hooks/multipartFormDataConfig';

interface UpdateWebsiteLogoParams {
  websiteId: string;
  file: File;
}

function updateWebsiteLogo({ websiteId, file }: UpdateWebsiteLogoParams) {
  const formData = new FormData();
  formData.append('logo', file);
  return axiosPrivate
    .put(
      `/v3/pharmacist/plus-websites/${websiteId}/themes/logos`,
      formData,
      multipartFormDataConfig
    )
    .then((r) => r.data);
}

export function useUpdateWebsiteLogo() {
  return useMutation({
    mutationFn: updateWebsiteLogo,
    onSuccess: () => broadcastPropsUpdated(),
    meta: {
      successMessage: 'Logo updated successfully',
      errorMessage: 'Failed to update logo',
    },
  });
}
